'use client';

import { useRouterI18n } from '@repo-ui/i18n/routing';
import { useEffect } from 'react';

export default function Page() {
  const router = useRouterI18n();
  useEffect(() => {
    router.push('/coding/list/block');
  }, [router]);

  return null;
}
